import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';
import Heading from 'shopper/components/Heading';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const TITLE = 'Últimos Comentários';

const LastCommentsHeading = ({ className, ...rest }) => (
  <div className={twMerge('mb-4', className)} {...rest}>
    <Breadcrumb>
      <BreadcrumbItem href={LINKS.HOME}>
        {placeholder('breadcrumbs.app')}
      </BreadcrumbItem>
      <BreadcrumbItem>{TITLE}</BreadcrumbItem>
    </Breadcrumb>
    <Heading as="h1" size="size3">
      {TITLE}
    </Heading>
  </div>
);

LastCommentsHeading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default LastCommentsHeading;
